<template lang="html">

    <section class="src-components-all-coupons">
        <b-modal ref="auth-result" title="BootstrapVue">
            <p class="my-4"
               v-bind:class="{ 'auth-message-success' : this.authSuccess, 'auth-message-fail': !this.authSuccess } ">{{
                authResult }}</p>
        </b-modal>

        <form>
            <b-form-group
                    id="fieldset-1"
                    label="Логін"
                    label-for="input-login"
            >
                <b-form-input id="input-login" v-model="login" trim></b-form-input>
            </b-form-group>

            <b-form-group
                    id="fieldset-2"
                    label="Пароль"
                    label-for="input-password"
            >
                <b-form-input type="password" id="input-password" v-model="password"
                              trim></b-form-input>
            </b-form-group>
            <div class="buttons">
                <b-button :disabled="!(login.length && password.length)" variant="success" @click="logIn()">Увійти</b-button>
            </div>
        </form>

    </section>

</template>

<script lang="js">
    import axios from 'axios';
    import { server } from '../variables';

    export default {
        name: 'src-components-login-page',
        props: [],
        components: {},
        mounted() {

        },
        data() {
            return {
                login: '',
                password: '',
                authResult: '',
                authSuccess: true,
            }
        },
        methods: {
            showModal() {
                this.$refs['auth-result'].show();
                setTimeout(() => {
                    this.$refs['auth-result'].hide();
                }, 2000);
            },
            logIn() {
                axios.post(`${ server }/login`, {
                    login: this.login,
                    password: this.password
                })
                    .then((data) => {
                        this.authSuccess = true;
                        this.$emit('refresh-header');
                        localStorage.setItem('token', data.data.token);
                        this.$router.push(`/home/stat`);
                    })
                    .catch(err => {
                        this.authSuccess = false;
                        this.authResult = `Такого користувача не існує`;
                        this.showModal();
                    })
            },

        },
        computed: {

        }
    }
</script>

<style lang="scss">
    .src-components-all-coupons {
        form {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

        .buttons {
            display: flex;
            button {
                margin: 0 16px;
            }
        }

        .modal {
            text-align: center;
        }

        .auth-message-success {
            color: green;
        }

        .auth-message-fail {
            color: red;
        }
    }
</style>
